const ROOT_KEY = "ims-store";
export default class Storage {
  path: string; // Storage Path
  data: any = {}; // Base Data
  constructor(dbName: string) {
    this.path = `${ROOT_KEY}/${dbName}`;
    this.load();
  }
  /** Load Data from Local Storage */
  load() {
    this.data = JSON.parse(localStorage.getItem(this.path) || "{}");
  }
  /** Save to LocalStorage  */
  save() {
    localStorage.setItem(this.path, JSON.stringify(this.data));
    return this;
  }
  /** GET key - or null */
  get(key: string) {
    return this.data[key] || null;
  }
  /** Get all Data */
  getAll() {
    return this.data;
  }
  /** Set key, value */
  set(key: string, value: any) {
    this.load();
    this.data[key] = value;
    return this.save();
  }
  /** Delete Key */
  delete(key: any) {
    this.data[key] = undefined;
    this.save();
  }
  /** Delete All  */
  deleteAll() {
    this.data = {};
    return this.save();
  }
}
